import { Component } from '@angular/core';

import { AuthService } from '../../../services/Security/auth.service';
import { UserService } from '../../../services/user/user.service';
import { EnvironmentVariablesService } from '../../../services/environment-variables.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: false,
})
export class HeaderComponent {
  checkboxes = [
    { name: 'Application Menu', checked: true },
    { name: 'Notifications', checked: true },
    { name: 'Help/Support', checked: true },
  ];

  userName = '';
  isAuthenticated = false;
  isAdmin: boolean = false;

  notificationModalOrigin = this.environmentVariables.NOTIFICATIONS_URL;
  releaseNotesUrl = '';

  constructor(
    public user: UserService,
    public auth: AuthService,
    public environmentVariables: EnvironmentVariablesService,
  ) {
    user.isAdmin.subscribe(v => {
      this.isAdmin = v;
    });
    user.userName.subscribe(value => {
      this.userName = value;
    });
    this.auth.$isAuthenticated.subscribe(response => {
      this.isAuthenticated = response.valueOf();
    });

    this.releaseNotesUrl =
      this.notificationModalOrigin +
      '/notifications/' +
      environmentVariables.PRODUCT_ID +
      '/' +
      environmentVariables.APPLICATION_NAME;
  }

  login() {
    this.user.login(window.location.pathname);
  }
  logout() {
    this.user.logout();
  }
}
